function removeCartItem(lineIndex, variantId) {
  var row = document.getElementById('CartItem-' + lineIndex);
  if (row) { row.style.opacity = '0.4'; row.style.pointerEvents = 'none'; }
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: lineIndex, quantity: 0 })
  })
  .then(function(r) { return r.json(); })
  .then(function() { location.reload(); })
  .catch(function() { location.href = '/cart/change?line=' + lineIndex + '&quantity=0'; });
}

function removeCoupon() {
  sessionStorage.removeItem('cq_discount');
  fetch('/discount/', { method: 'GET', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function () {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      });
    })
    .catch(function () {})
    .finally(function () { location.reload(); });
}

document.addEventListener('DOMContentLoaded', function () {
  var coupons   = window.CQ_COUPONS || [];
  var field     = document.getElementById('cq-coupon-field');
  var applyBtn  = document.getElementById('cq-coupon-btn');
  var msgEl     = document.getElementById('cq-coupon-msg');
  var viewBtn   = document.getElementById('cq-view-coupons-btn');
  var overlay   = document.getElementById('cq-modal-overlay');
  var closeBtn  = document.getElementById('cq-modal-close');
  var modalBody = document.getElementById('cq-modal-body');
  var jsBox     = document.getElementById('cq-applied-box-js');
  var jsCodeEl  = document.getElementById('cq-applied-code-display');

  function buildModal() {
    modalBody.innerHTML = '';
    if (!coupons.length) {
      modalBody.innerHTML = '<p style="color:var(--black-8);text-align:center;padding:20px 0;">No coupons available right now.</p>';
      return;
    }
    coupons.forEach(function (c) {
      var card = document.createElement('div');
      card.className = 'cq-coupon-card';
      card.innerHTML = '<div class="cq-coupon-card__left"><span class="cq-coupon-card__code">' + c.code + '</span><span class="cq-coupon-card__desc">' + (c.desc || '') + '</span></div><button class="cq-coupon-card__btn" type="button">Apply</button>';
      function doApply() { field.value = c.code; closeModal(); setTimeout(function () { applyBtn.click(); }, 120); }
      card.querySelector('.cq-coupon-card__btn').addEventListener('click', doApply);
      card.addEventListener('click', function (e) { if (e.target.tagName !== 'BUTTON') doApply(); });
      modalBody.appendChild(card);
    });
  }

  function openModal()  { buildModal(); overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeModal() { overlay.classList.remove('open'); document.body.style.overflow = ''; }

  viewBtn  && viewBtn.addEventListener('click', openModal);
  closeBtn && closeBtn.addEventListener('click', closeModal);
  overlay  && overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  function applyCoupon(code) {
    if (!code) { showMsg('Please enter a discount code.', 'error'); return; }
    applyBtn.textContent = 'Applying...';
    applyBtn.disabled = true;
    msgEl.className = 'cq-coupon-msg';
    msgEl.style.display = 'none';

    fetch('/discount/' + encodeURIComponent(code), { method: 'GET', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function () { return fetch('/cart.js'); })
    .then(function (r) { return r.json(); })
    .then(function (cartData) {
      var discounts = cartData.cart_level_discount_applications || [];
      var found = discounts.find(function (d) { return d.code && d.code.toUpperCase() === code.toUpperCase(); });

      if (found || discounts.length > 0) {
        var usedCode = (found ? found.code : (discounts[0].code || code)).toUpperCase();
        showMsg('✓ Coupon "' + usedCode + '" applied!', 'success');
        if (jsBox && jsCodeEl) { jsCodeEl.textContent = '🏷️ ' + usedCode; jsBox.classList.add('show'); }
        applyBtn.textContent = 'Applied ✓';
        setTimeout(function () { location.reload(); }, 1200);
      } else {
        showMsg('✓ Coupon saved! Applying at checkout...', 'success');
        if (jsBox && jsCodeEl) { jsCodeEl.textContent = '🏷️ ' + code.toUpperCase(); jsBox.classList.add('show'); }
        applyBtn.textContent = 'Applied ✓';
        sessionStorage.setItem('cq_discount', code.toUpperCase());
        var cb = document.getElementById('cq-checkout-btn');
        if (cb) cb.href = '/checkout?discount=' + encodeURIComponent(code);
        setTimeout(function () { location.reload(); }, 800);
      }
    })
    .catch(function () {
      showMsg('✗ Something went wrong. Try again.', 'error');
      applyBtn.textContent = 'Apply Discount';
      applyBtn.disabled = false;
    });
  }

  function showMsg(text, type) { msgEl.textContent = text; msgEl.className = 'cq-coupon-msg ' + type; }

  applyBtn && applyBtn.addEventListener('click', function () { applyCoupon(field.value.trim()); });
  field    && field.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyCoupon(field.value.trim()); } });

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var discounts = cart.cart_level_discount_applications || [];
      if (discounts.length > 0 && discounts[0].code) {
        if (field) field.value = discounts[0].code.toUpperCase();
        if (applyBtn) applyBtn.textContent = 'Applied ✓';
        sessionStorage.removeItem('cq_discount');
      } else {
        var savedCode = sessionStorage.getItem('cq_discount');
        if (savedCode) {
          if (field) field.value = savedCode;
          if (applyBtn) applyBtn.textContent = 'Applied ✓';
          if (jsBox && jsCodeEl) { jsCodeEl.textContent = '🏷️ ' + savedCode; jsBox.classList.add('show'); }
          var cb = document.getElementById('cq-checkout-btn');
          if (cb) cb.href = '/checkout?discount=' + encodeURIComponent(savedCode);
        }
      }
    });
});